<template>
  <el-dialog width="900px"
             v-dialog-drag
             title="生成体验版"
             :before-close="handleClickCancel"
             :close-on-press-escape="false"
             :close-on-click-modal="false"
             :visible.sync="weChatCommitTrialVisible">
    <el-form size="small"
             ref="trialForm"
             label-position="top"
             label-width="85px"
             :model="trialForm"
             :rules="trialFormRules" v-loading="loading">
<!--      <el-tabs v-model="activeName" @tab-click="handleClickTab">-->
<!--        <el-tab-pane label="普通模板" name="0">-->

<!--        </el-tab-pane>-->
<!--        <el-tab-pane label="标准模板" name="1">-->

<!--        </el-tab-pane>-->
<!--      </el-tabs>-->
      <div style="margin-bottom: 16px">
        <el-table :data="tableData" max-height="300"  border   style="width: 100%" @cell-click="handleClickCell">
          <el-table-column  fixed prop="change"  label="选择" align="center" width="60">
            <template slot-scope="{row}">
              <div class="custom_radio">
                <el-radio v-model="templateId" :label="row.template_id"> </el-radio>
              </div>

            </template>
          </el-table-column>
          <el-table-column   prop="template_type"  label="模板类型" align="center" width="100">
            <template slot-scope="{row}">
              <span v-text="row.template_type == 0 ? '普通模板' : row.template_type == 1 ? '标准模板' : ''"></span>
            </template>
          </el-table-column>


          <el-table-column  prop="user_version" label="版本号" align="center" width="80" show-overflow-tooltip	> </el-table-column>
          <el-table-column  prop="user_desc" label="描述"  align="center"  min-width="120" show-overflow-tooltip	> </el-table-column>
          <el-table-column  prop="template_id" label="templateID" align="center"  width="120" show-overflow-tooltip	> </el-table-column>
          <el-table-column  prop="create_time" label="添加到模板库时间"  align="center" width="160" show-overflow-tooltip	>
            <template slot-scope="{row}">
              <span v-text="timeDate(row.create_time)"></span>
            </template>

          </el-table-column>
          <el-table-column  prop="audit_status" label="审核状态"  align="center" width="100" show-overflow-tooltip	>
            <template slot-scope="{row}">
              <span v-text="audit_status_text(row.audit_status)"></span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-form-item label="代码版本号" prop="user_version">
        <el-input placeholder="请输入代码版本号" v-model="trialForm.user_version"></el-input>
      </el-form-item>
      <el-form-item label="代码描述" prop="user_desc">
        <el-input placeholder="请输入代码描述" v-model="trialForm.user_desc" type="textarea"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="small"   :disabled="btnDisabled" @click="handleClickCancel">取消</el-button>
      <el-button size="small"   :disabled="btnDisabled" @click="handleClickConfirm" type="primary">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { getTemplateList,weChatCommitTrial} from "@/api";

export default {
  name: "wechat_commitTrial",
  props: {
    weChatCommitTrialVisible: {
      type: Boolean,
      default: false,
    },
    weChatAppId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      btnDisabled: false,
      trialForm: {
        appid: '',
        user_version:'',
        user_desc:''
      },
      trialFormRules: {
        user_version: [{required: true, message: '请输入版本号', trigger: 'blur'},],
        user_desc: [{required: true, message: '请输入代码描述', trigger: 'blur'},],
      },
      activeName:'0',
      tableData:[],
      templateId:null
    }
  },
  created() {
   if(this.weChatAppId){
     this.trialForm.appid = this.weChatAppId
   }
   this.getTableData(0)
  },
  mounted() {
  },
  methods: {
    handleClickTab(val){
      console.log(val)
    },
    handleClickCell(row, column, cell, event){
      this.templateId = row.template_id
    },
    getTableData(template_type) {
      this.loading = true
      getTemplateList({
        template_type: template_type,
      }).then(res => {
        if (res.code === 200) {
          this.tableData = res.data
          if(res.data.length>0){
            this.templateId = res.data[0].template_id
          }
        }
        this.loading = false
      })
    },

    timeDate(timestampInSeconds ){
      // 转换为毫秒
      const timestampInMilliseconds = timestampInSeconds * 1000;

// 创建 Date 对象
      const date = new Date(timestampInMilliseconds);
//    自定义格式：YYYY-MM-DD HH:mm:ss
      const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
      return formattedDate
    },

    audit_status_text(status){
        let text = ''
        if(status == 0){text = '未提审核'}
        if(status == 1){text = '审核中'}
        if(status == 2){text = '审核驳回'}
        if(status == 3){text = '审核通过'}
        if(status == 4){text = '提审中'}
        if(status == 5){text = '提审失败'}
        return text
    },

    handleClickCancel() {
      this.$refs.trialForm.resetFields()
      this.$emit('update:weChatCommitTrialVisible', false)
    },

    handleClickConfirm() {
      this.$refs.trialForm.validate(valid => {
        if (valid) {
          this.btnDisabled = true
          weChatCommitTrial({
            template_id:this.templateId,
            user_version:this.trialForm.user_version,
            user_desc:this.trialForm.user_desc,
          },{
            headers:{
              appid: this.trialForm.appid,
            }
          }).then(res => {
            this.$message.success(res.message)
            this.$emit('success')
            this.$refs.trialForm.resetFields()
            this.$emit('update:weChatCommitTrialVisible', false)
          }).catch(() => {
            this.btnDisabled = false
          })
        } else {
          return false
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.el-date-editor.el-input {
  width: 100%;
}
.custom_radio ::v-deep .el-radio__label{
  display: none;
}
</style>
